import { Directive,Input,HostListener } from '@angular/core';
import { ExportService } from '../Service/export.service';

@Directive({
  selector: '[appExport]'
})
export class ExportDirective {

  
  constructor(private exportService:ExportService) { }
  

  @Input('appExport') dataList: any[];
  @Input() fileName: string;
  converted
  

  @HostListener('click', ['$event']) onClick($event) {
   
    if(this.fileName=="PasskeyReport")
    {
    this.dataList=this.dataList.map(({
      TRAINING_COURSE_NAME:TrainingCourse,NAME:Name,PASSKEY:Passkey,PASSKEY_EXPIRY_TIME:Expiry,STUDENT_COUNT:Students }) => 
     ({TrainingCourse,Name,Passkey,Expiry,Students}));
     this.converted =  this.dataList
     //this.converted =  this.rekey(this.dataList, { TRAINING_COURSE_NAME: 'Course Name',NAME: 'Batch Name',PASSKEY: 'Passkey',PASSKEY_EXPIRY_TIME: 'Passkey Expiry'});
    }
    else if(this.fileName=="PartReport")
    {
    this.dataList=this.dataList.map(({
      NAME:Name ,DESCRIPTION:Description,SECTION_COUNT:Sections,CHAPTER_COUNT:Chapters,SUB_CHAPTER_COUNT:SubChapters,AQG_TEMPLATE_COUNT:AQGTemplates,CLASSWORK_QUESTION_COUNT:Classwork_Questions,HOMEWORK_QUESTION_COUNT:Homework_questions,PRACTICE_QUESTION_COUNT:Practice_Questions,ASSIGNMENT_QUESTION_COUNT:Assignmnet_Questions,COMBAT_QUESTION_COUNT:Combat_Questions,AQG_QUESTION_COUNT:AQG_Questions  }) => 
     ({Name,Description,Sections,Chapters,SubChapters,AQGTemplates,Classwork_Questions,Homework_questions,Practice_Questions,Assignmnet_Questions,Combat_Questions,AQG_Questions}));
     this.converted =  this.dataList
    
    }
    else  if(this.fileName=="SectionReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_Name, NAME: Name ,DESCRIPTION:Description,CHAPTER_COUNT:Chapters,SUB_CHAPTER_COUNT:SubChapters,AQG_TEMPLATE_COUNT:AQGTemplates,CLASSWORK_QUESTION_COUNT:Classwork_Questions,HOMEWORK_QUESTION_COUNT:Homework_questions,PRACTICE_QUESTION_COUNT:Practice_Questions,ASSIGNMENT_QUESTION_COUNT:Assignmnet_Questions,COMBAT_QUESTION_COUNT:Combat_Questions,AQG_QUESTION_COUNT:AQG_Questions  }) => 
     ({Part_Name,Name,Description,Chapters,SubChapters,AQGTemplates,Classwork_Questions,Homework_questions,Practice_Questions,Assignmnet_Questions,Combat_Questions,AQG_Questions}));
     this.converted =  this.dataList
    
    }
    else  if(this.fileName=="ChapterReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_Name,SECTION_NAME:Section_Name, NAME: Name ,DESCRIPTION:Description,SUB_CHAPTER_COUNT:SubChapters,AQG_TEMPLATE_COUNT:AQGTemplates,CLASSWORK_QUESTION_COUNT:Classwork_Questions,HOMEWORK_QUESTION_COUNT:Homework_questions,PRACTICE_QUESTION_COUNT:Practice_Questions,ASSIGNMENT_QUESTION_COUNT:Assignmnet_Questions,COMBAT_QUESTION_COUNT:Combat_Questions,AQG_QUESTION_COUNT:AQG_Questions  }) => 
     ({Part_Name,Section_Name,Name,Description,SubChapters,AQGTemplates,Classwork_Questions,Homework_questions,Practice_Questions,Assignmnet_Questions,Combat_Questions,AQG_Questions}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="SubChapterReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_Name,SECTION_NAME:Section_Name,CHAPTER_NAME:Chapter_Name,NAME: Name ,DESCRIPTION:Description,AQG_TEMPLATE_COUNT:AQGTemplates,CLASSWORK_QUESTION_COUNT:Classwork_Questions,HOMEWORK_QUESTION_COUNT:Homework_questions,PRACTICE_QUESTION_COUNT:Practice_Questions,ASSIGNMENT_QUESTION_COUNT:Assignmnet_Questions,COMBAT_QUESTION_COUNT:Combat_Questions,AQG_QUESTION_COUNT:AQG_Questions  }) => 
     ({Part_Name,Section_Name,Chapter_Name,Name,Description,AQGTemplates,Classwork_Questions,Homework_questions,Practice_Questions,Assignmnet_Questions,Combat_Questions,AQG_Questions}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="BatchReport")
    {
    this.dataList=this.dataList.map(({
      NAME:Name,PASSKEY:Passkey,PASSKEY_EXPIRY_TIME:PasskeyExpiry,STUDENT_COUNT:Count  }) => 
     ({Name,Passkey,PasskeyExpiry,Count}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="BatchStudentReport")
    {
    this.dataList=this.dataList.map(({
      BATCH_NAME:Batch,STUDENT_NAME:StudentName,EMAIL_ID:EmailId,MOBILE_NO:Mobile,JOINING_DATE:RegistrationDate,PRN:PRN  }) => 
     ({Batch,StudentName,EmailId,Mobile,RegistrationDate,PRN}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="MasterSessionReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_Name,SECTION_NAME:Section_Name,CHAPTER_NAME:Chapter_Name,NAME: Name,SUB_CHAPTER_COUNT:SubChapters,IDLE_DELIVERY_TIME:Idle_Delivery_Time,IDLE_SESSIONS_COUNT:Idle_Session_Count,SEQUENCE_NO:SequenceNo,PUBLISH_CHAPTER:Publish_Chapter }) => 
      ({Part_Name,Section_Name,Chapter_Name,Name,SubChapters,Idle_Delivery_Time,Idle_Session_Count,SequenceNo,Publish_Chapter}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="BatchSessionReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_Name,SECTION_NAME:Section_Name,CHAPTER_NAME:Chapter_Name,BATCH_NAME:Batch_Name,NAME: Name,SUB_CHAPTER_COUNT:SubChapters,DELIVERY_TIME:Idle_Delivery_Time,SESSIONS_COUNTER:Idle_Session_Count,SEQUENCE_NO:SequenceNo}) => 
      ({Part_Name,Section_Name,Chapter_Name,Batch_Name,Name,SubChapters,Idle_Delivery_Time,Idle_Session_Count,SequenceNo}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="MasterSessionDetailsReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_name,SECTION_NAME:Section_Name,CHAPTER_NAME:Chapter_Name,SUB_CHAPTER_NAME:Sub_chapter_Name,SESSION_NAME:Session_Name,TYPE_NAME:Type,WEIGHTAGE:Weight,L1_CLASSWORK_QUESTIONS_COUNT: L1Questions,L2_CLASSWORK_QUESTIONS_COUNT: L2Questions,L3_CLASSWORK_QUESTIONS_COUNT: L3Questions,L4_CLASSWORK_QUESTIONS_COUNT: L4Questions,L5_CLASSWORK_QUESTIONS_COUNT: L5Questions}) => 
      ({Part_name,Section_Name,Chapter_Name,Sub_chapter_Name,Session_Name,Type,Weight,L1Questions,L2Questions,L3Questions,L4Questions,L5Questions}));
     this.converted =  this.dataList
    }
    else  if(this.fileName=="BatchSessionDetailsReport")
    {
    this.dataList=this.dataList.map(({
      PART_NAME:Part_name,SECTION_NAME:Section_Name,CHAPTER_NAME:Chapter_Name,SUB_CHAPTER_NAME:Sub_chapter_Name,BATCH_NAME:Batch_Name,BATCH_SESSION_SYLLABUS_NAME:Session_Name,WEIGHTAGE:Weight,L1_CLASSWORK_QUESTIONS_COUNT: L1Questions,L2_CLASSWORK_QUESTIONS_COUNT: L2Questions,L3_CLASSWORK_QUESTIONS_COUNT: L3Questions,L4_CLASSWORK_QUESTIONS_COUNT: L4Questions,L5_CLASSWORK_QUESTIONS_COUNT: L5Questions}) => 
      ({Part_name,Section_Name,Chapter_Name,Sub_chapter_Name,Batch_Name,Session_Name,Weight,L1Questions,L2Questions,L3Questions,L4Questions,L5Questions}));
     this.converted =  this.dataList
    }
    else if(this.fileName=="CourseTypes")
    {
      this.dataList=this.dataList.map(({
        NAME,SEQUENCE_NO}) => 
       ({NAME,SEQUENCE_NO}));
       this.converted =  this.rekey(this.dataList, { NAME: 'Name',SEQUENCE_NO: 'Sequence No'});
    }
    else if(this.fileName=="Courses")
    {
      this.dataList=this.dataList.map(({
        COURSE_TYPE_NAME:Course_type,NAME:Name,SEQUENCE_NO:Sequence_No,ABBREVATION:Abbreviation,START_DATE:Start_Date,END_DATE:End_Date,COURSE_FEE:Course_Fee,SUBSCRIBERS:Subscribers,RATINGS:Rating}) => 
       ({Course_type,Name,Sequence_No,Abbreviation,START_DATE:Start_Date,End_Date,Course_Fee,Subscribers,Rating}));
       this.converted =  this.dataList
      // this.converted =  this.rekey(this.dataList, { COURSE_TYPE_NAME:'Course Type', NAME: 'Name', SEQUENCE_NO: 'Sequence No', ABBREVATION: 'Abbreviation', START_DATE: 'Start Date', END_DATE: 'End Date', COURSE_FEE:'Course Fee', SUBSCRIBERS:'Subcribers', RATINGS:'Ratings'});
    }
    else if(this.fileName=="CourseChapters")
    {
      console.log(this.dataList)
      this.dataList=this.dataList.map(({
        COURSE_NAME:Course_Name,CHAPTER_PARENT_NAME:Chapter_Parent_Name,NAME:Name,DEPENDED_CHAPTER_NAME:Dependent_Chapter_Name,DESCRIPTION:Description}) => 
       ({Course_Name,Chapter_Parent_Name,Name,Dependent_Chapter_Name,DESCRIPTION:Description}));
       this.converted =  this.dataList

       //this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course', CHAPTER_PARENT_NAME: 'Parent Name', NAME: 'Name', DEPENDED_CHAPTER_NAME: 'Dependent Chapter Name', DESCRIPTION: 'Description'});
    }
    else if(this.fileName=="Documents")
    {
      this.dataList=this.dataList.map(({
        SHIKUYAA_CHAPTER_NAME,NAME,SEQ_NO}) => 
       ({SHIKUYAA_CHAPTER_NAME,NAME,SEQ_NO}));
       this.converted =  this.rekey(this.dataList, { SHIKUYAA_CHAPTER_NAME:'Course', NAME: 'Name', SEQ_NO: 'Sequence No'});
    } 
    else if(this.fileName=="VideoQuestionTypes")
    {
      this.dataList=this.dataList.map(({
        NAME}) => 
       ({NAME}));
       this.converted =  this.rekey(this.dataList, { NAME: 'Name'});
    } 
    else if(this.fileName=="Videos")
    {
      this.dataList=this.dataList.map(({
        CHAPTER_NAME,NAME,DESCRIPTION,URL_KEY,DURATION}) => 
       ({CHAPTER_NAME,NAME,DESCRIPTION,URL_KEY,DURATION}));
       this.converted =  this.rekey(this.dataList, { CHAPTER_NAME:'Chapter ',NAME: 'Name',DESCRIPTION:'Description',URL_KEY:'Url Key',DURATION:'Duration'});
    } 
    else if(this.fileName=="LiveVideos")
    {
      this.dataList=this.dataList.map(({
        COURSE_NAME,NAME,DESCRIPTION,START_DATE_TIME,DISABLE_DATE_TIME,VIDEO_KEY}) => 
       ({COURSE_NAME,NAME,DESCRIPTION,START_DATE_TIME,DISABLE_DATE_TIME,VIDEO_KEY}));
       this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course',NAME: 'Name',DESCRIPTION:'Description',START_DATE_TIME:'Start Time',DISABLE_DATE_TIME:'Disable Time',VIDEO_KEY:'Video Key'});
    } 
    else if(this.fileName=="CourseParagraph")
    {
      this.dataList=this.dataList.map(({
        PARAGRAPH_TEXT}) => 
       ({PARAGRAPH_TEXT}));
       this.converted =  this.rekey(this.dataList, { PARAGRAPH_TEXT:'Paragraph Text'});
    } 
    else if(this.fileName=="CourseQuestions")
    {
      this.dataList=this.dataList.map(({
        CHAPTER_NAME,QUESTION_TYPE_NAME,LEVEL_NAME,DIRECTION,DESCRITION,QUESTION,SOLUTION,SOLUTION_VIDEO_URL}) => 
       ({CHAPTER_NAME,QUESTION_TYPE_NAME,LEVEL_NAME,DIRECTION,DESCRITION,QUESTION,SOLUTION,SOLUTION_VIDEO_URL}));
       this.converted =  this.rekey(this.dataList, { CHAPTER_NAME:'Chapter Name',QUESTION_TYPE_NAME:'Question Type Name',LEVEL_NAME:'Level Name',DIRECTION:'Direction',DESCRITION:'Description',QUESTION:'Question',SOLUTION:'Solution',SOLUTION_VIDEO_URL:'Solution Video Url'});
    } 
    else if(this.fileName=="CouponFacilities")
    {
      this.dataList=this.dataList.map(({
        NAME}) => 
       ({NAME}));
       this.converted =  this.rekey(this.dataList, { NAME:'Name'});
    } 
    else if(this.fileName=="Coupons")
    {
      this.dataList=this.dataList.map(({
        NAME,START_DATE,EXPIRY_DATE,MAX_USES_COUNT,COUPON_CODE,COUPON_VALUE,COUPON_MAX_VALUE,PERUSER_MAX_COUNT,MIN_CART_AMOUNT}) => 
       ({NAME,START_DATE,EXPIRY_DATE,MAX_USES_COUNT,COUPON_CODE,COUPON_VALUE,COUPON_MAX_VALUE,PERUSER_MAX_COUNT,MIN_CART_AMOUNT}));
       this.converted =  this.rekey(this.dataList, { NAME:'Name', START_DATE:'Start Date',EXPIRY_DATE:'Expiry Date',MAX_USES_COUNT:'Max Uses Count',COUPON_CODE:'Coupon Code',COUPON_VALUE:'Coupon Value',COUPON_MAX_VALUE:'Coupon Max Value',PERUSER_MAX_COUNT:'Per User Max Count',MIN_CART_AMOUNT:'Min Cart Amount'});
    } 
    else if(this.fileName=="PredefinedMock")
    {
      this.dataList=this.dataList.map(({
        COURSE_NAME,NAME,PRICE,NO_OF_QUESTION,TOTAL_TIME}) => 
       ({COURSE_NAME,NAME,PRICE,NO_OF_QUESTION,TOTAL_TIME}));
       this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', NAME:'Name',PRICE:'Price', NO_OF_QUESTION:'No Of Questions',TOTAL_TIME:'Total Time'});
    } 
    else if(this.fileName=="StudentCourseList")
    {
      this.dataList=this.dataList.map(({
        COURSE_NAME:Course_Name,F_NAME:F_Name,M_NAME:M_Name,L_NAME:L_Name,MOBILE_NO:Mobile,WHATS_APP_NO:WhatsApp,EMAIL_ID:Email,REGISTRATION_DATE:Registration_date,PURCHASE_DATE:Purchase_Date,REFERENCE_COUPON_CODE:Reference_Coupon_Code,MAIN_WALLET_BALANCE:Main_Wallet_Balance,COURSE_PAID_AMOUNT:Course_Paid_Amount,POINTS:Points}) => 
       ({Course_Name,F_Name,M_Name,L_Name,Mobile,WhatsApp,Email,Registration_date,Purchase_Date,Reference_Coupon_Code,Main_Wallet_Balance,Course_Paid_Amount,Points}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    } 
    else if(this.fileName=="VideoStatsList")
    {
      this.dataList=this.dataList.map(({
        VIDEO_NAME:Video_Name,SHARE_COUNT:Share_Count,DOUBTS_COUNT:Doubts_Count,WACHED_USER_COUNT:Watched_User_count,DURATION:Duration,AVG_VIDEO_WATCHED:Ang_Video_Watched}) => 
       ({Video_Name,Share_Count,Doubts_Count,Watched_User_count,Duration,Ang_Video_Watched}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    } 
    else if(this.fileName=="CourseSummery")
    {
      this.dataList=this.dataList.map(({
        NAME:Name,FREE_TRIAL_TAKENS:Free_Trial_Taken,SUBSCRIBERS:Subcribers,RATINGS:Ratings,VIDEO_COUNT:Videos_Count,LIVE_COMPLETED_VIDEOS:Live_Completed_Videos,MOCK_COUNT:Mock_count,CHAPTERS_COUNT:Chapter_Count,QUESTIONS_COUNT:Question_Count,REFERENCE_COUPON_CODE:Reference_Coupon_Code,TOTAL_STUDENT_COUNT:Total_Student_Count}) => 
       ({Name,Free_Trial_Taken,Subcribers,Ratings,Videos_Count,Live_Completed_Videos,Mock_count,Chapter_Count,Question_Count,Reference_Coupon_Code,Total_Student_Count}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    } 
    else if(this.fileName=="ChapterSummery")
    {
      this.dataList=this.dataList.map(({
        NAME:Name,CHILDREN_CHAPTER_:Children_Count,TOTAL_PRACTICE_QUESTIONS:Practice_Que_count,TOTAL_PREDEFINED_MOCK_QUESTIONS:Predefined_Mock_Que_count,TOTAL_LIVE_MOCK_QUESTIONS:Live_Mock_Que_Count,TOTAL_DOCUMENTS:Document_Count,VIDEO_COUNT:Video_Count}) => 
       ({Name,Children_Count,Practice_Que_count,Predefined_Mock_Que_count,Live_Mock_Que_Count,Document_Count,Video_Count}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    } 
    else if(this.fileName=="LiveVideoSummery")
    {
      this.dataList=this.dataList.map(({
        LIVE_VIDEO_NAME:Name,LIKE_COUNT:Like_Count,DISLIKE_COUNT:Dislike_Count,SHARE_COUNT:Share_Count,WATCHED_COUNT:Watched_Count,LIVE_COUNT:Live_Count}) => 
       ({Name,Like_Count,Dislike_Count,Share_Count,Watched_Count,Live_Count}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    } 
    else if(this.fileName=="LiveVideoReport")
    {
      this.dataList=this.dataList.map(({
        LIVE_VIDEO_NAME:Name,F_NAME:First_Name,M_NAME:Middle_Name,L_NAME:Last_Name,MOBILE_NO:Mobile_No,LIVE_TIME:Online_Time,OFFLINE_TIME:Offline_Time}) => 
       ({Name,First_Name,Middle_Name,Last_Name,Mobile_No,Online_Time,Offline_Time}));
       this.converted =  this.dataList
       
      // this.converted =  this.rekey(this.dataList, { COURSE_NAME:'Course Name', F_NAME:'First Name', M_NAME:'Middle Name', L_NAME:'Last Name',MOBILE_NO:'Mobile No', WHATS_APP_NO:'Whats App No',EMAIL_ID:'Email Id',REGISTRATION_DATE:'Registration Date',PURCHASE_DATE:'Purchase Date',REFERENCE_COUPON_CODE:'Reference Coupon Code',MAIN_WALLET_BALANCE:'Main Wallet Balance',COURSE_PAID_AMOUNT:'Course Paid Amount',POINTS:'Points'});
    }
    else if(this.fileName=="SessionReport")
    {
      this.dataList=this.dataList.map(({
        DATE:Date,START_TIME_END_TIME_TEXT:Time,NAME:Name,TRAINER_NAME:Trainer_Name,BATCH_NAME:Batch_Name,TOTAL_STUDENTS:Total_Students,START_TIME:Start_Time,COMPLETED_TIME:Completed_Time,TRAINER_RATINGS:Trainer_Ratings}) => 
       ({Date,Time,Name,Trainer_Name,Batch_Name,Total_Students,Start_Time,Completed_Time,Trainer_Ratings}));
       this.converted =  this.dataList
    }
    else if(this.fileName=="MandayCalculationReport")
    {
      this.dataList=this.dataList.map(({
        SR_NO:SrNo,TRAINER_NAME:Trainer_Name,DATE:Date,COLLEGE_NAME:College_Name,TIME_SPAN:Time_Span,MANDAYS:Mandays}) => 
       ({SrNo,Trainer_Name,Date,College_Name,Time_Span,Mandays}));
       this.converted =  this.dataList
    }
    else if(this.fileName=="RenumerationCalculationReport")
    {
      this.dataList=this.dataList.map(({
        SR_NO:SrNo,TRAINER_NAME:Trainer_Name,DATE:Date,COLLEGE_NAME:College_Name,TIME_SPAN:Time_Span,MANDAYS:Mandays,EXTRA_HRS:ExtraHrs}) => 
       ({SrNo,Trainer_Name,Date,College_Name,Time_Span,Mandays,ExtraHrs}));
       this.converted =  this.dataList
    }
    else if(this.fileName=="RatingsReport")
    {
      this.dataList=this.dataList.map(({
        SR_NO:SrNo,TRAINER_NAME:Trainer_Name,COLLEGE_NAME:College_Name,DATE:Date,BATCH_NAME:Batch_Name,AVERAGE_RATING:Avearage_Rating_Per_Session,STUDENT_COUNT:Student_Count,AVERAGE_RATING_PERCENTAGE:Average_Rating_Percentage,AVERAGE_RATING_PERCENTAGE1:Average_Rating_Percentage1}) => 
       ({SrNo,Trainer_Name,College_Name,Date,Batch_Name,Avearage_Rating_Per_Session,Student_Count,Average_Rating_Percentage,Average_Rating_Percentage1}));
       this.converted =  this.dataList
    }
    else if(this.fileName=="SuggeestionReport")
    {
      this.dataList=this.dataList.map(({
        SR_NO:SrNo,TRAINER_NAME:Trainer_Name,DATE:Date,COLLEGE_NAME:College_Name,BATCH_NAME:Batch_Name,SUGGEESTION_COUNT:Suggeestion_Count,SUGGEESTIONS:Suggeestion}) => 
       ({SrNo,Trainer_Name,Date,College_Name,Batch_Name,Suggeestion_Count,Suggeestion}));
       this.converted =  this.dataList
    }
    else if(this.fileName=="SyllabusCompletionTrackReport")
    {
      // this.dataList=this.dataList.map(({
      //   SR_NO:SrNo,TRAINER_NAME:Trainer_Name,DATE:Date,COLLEGE_NAME:College_Name,BATCH_NAME:Batch_Name,SUGGESTION_COUNT:Suggeestion_Count,SUGGESSTION:Suggeestion}) => 
      //  ({SrNo,Trainer_Name,Date,College_Name,Batch_Name,Suggeestion_Count,Suggeestion}));
      //  this.converted =  this.dataList
    }


    

   this.exportService.exportExcel(this.converted, this.fileName);
   
  }
 

  rekey(arr, lookup) {
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i];
      for (var fromKey in lookup) {
        var toKey = lookup[fromKey];
        var value = obj[fromKey];
        if (value) {
          obj[toKey] = value;
          delete obj[fromKey];
        }
      }
    }
    return arr;
  }

 
 }
